module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Chaise_Caramel.ac05ff80.png";